export enum DeviceOrientation {
    Portrait = "portrait",
    Landscape = "landscape",
}
